<div
  class="loading"
  [ngClass]="{ fullscreen: fullscreen }">
  <div class="lds-ellipsis">
    <div class="primary"></div>
    <div class="primary"></div>
    <div class="primary"></div>
    <div class="primary"></div>
  </div>
</div>
